export const SUGGEST_AFTER_LEAD_ENABLED = false
export const SUGGEST_DEFAULT_LOGIN_ENABLED = false
export const MOBILE_ASSET_PATH = ''
export const MOBILE_INSTALL_URL = ''
export const DESKTOP_QR_CODE_PATH = ''
export const DESKTOP_QR_CODE_LOGIN_PATH = ''
